/*
  Графы бланка домовой книги одного человека - имена полей те же, что на сервере
  (`app/imports/universal/scans.py`, `PERSON_FIELDS`). `registered_since` - дата
  из графы «Когда и откуда прибыл»: имя осталось от первой редакции сверки.
*/

// Рождение, прибытие и выбытие - парой «когда - где», как в графах бланка.
export const PAIRS = [
  ['Рождение', 'birth_date', 'birth_place'],
  ['Прибыл', 'registered_since', 'arrived_from'],
  ['Выбыл', 'left_on', 'left_to'],
]

export const SINGLES = [
  ['purpose', 'Цель прибытия'],
  ['passport', 'Паспорт'],
  ['citizenship', 'Гражданство'],
]

export const PERSON_FIELDS = [
  'full_name',
  ...PAIRS.flatMap(([, when, where]) => [when, where]),
  ...SINGLES.map(([name]) => name),
]

export const EMPTY_PERSON = Object.fromEntries(PERSON_FIELDS.map((name) => [name, '']))

/*
  Предел длины каждого поля сверки (01.10.2026, проверка перед выкладкой).
  Сервер отказывает превышению (422), и без предела у поля человек узнавал об
  этом, только вписав всю страницу. Числа - длины колонок, куда поле ложится:
  - счёт - `accounts.number`, 64;
  - ФИО - `account_residents.full_name`, 256;
  - место рождения, откуда прибыл, куда выбыл - `account_residents`, 255;
  - цель прибытия - 128, гражданство - 64 (`account_residents`).
  Адрес лежит в `accounts.address` без предела (Text); 512 - как у адреса в
  обмене с 1С (`schemas/connector.py`). Даты и паспорт хранятся не строкой:
  сервер разбирает их и приводит к виду сам, предел 32 только не даёт вставить
  в графу абзац.
*/
export const FIELD_LIMITS = {
  account_number: 64,
  address: 512,
  full_name: 256,
  birth_date: 32,
  birth_place: 255,
  registered_since: 32,
  arrived_from: 255,
  left_on: 32,
  left_to: 255,
  purpose: 128,
  passport: 32,
  citizenship: 64,
}
